import moment from 'moment'
import {useSelector} from 'react-redux'

export const policy_types = [
  {
    id: 'Privacy',
    label: 'Privacy',
  },
  {
    id: 'TermsCondition',
    label: 'Terms & Condition',
  },
  {
    id: 'ApplicationPolicy',
    label: 'Application Policy',
  },
  {
    id: 'RefundPolicy',
    label: 'Refund Policy',
  },
  {
    id: 'EULA (End user license agreement)',
    label: 'EULA (End user license agreement)',
  },
]

export const application_setting_tabs = [
  {
    title: 'Auth',
    path: '/application_setting/auth',
  },
  {
    title: 'Web Settings',
    path: '/application_setting/web_setting',
  },
  {
    title: 'SMTP Settings',
    path: '/application_setting/smtp_setting',
  },
  {
    title: 'SMS Settings',
    path: '/application_setting/sms_setting',
  },
  {
    title: 'General Settings',
    path: '/application_setting/general_setting',
  },
  {
    title: 'Payment Credentials',
    path: '/application_setting/payment_setting',
  },
  {
    title: 'Appointment Settings',
    path: '/application_setting/appointment_setting',
  },
  {
    title: 'Social Settings',
    path: '/application_setting/social_setting',
  },
  {
    title: 'Fresdesk Settings',
    path: '/application_setting/freshdesk_setting',
  },
  {
    title: 'App Version Settings',
    path: '/application_setting/appversion_setting',
  },
  {
    title: 'Med Gemini & AI',
    path: '/application_setting/med-gemini-ai',
  },
  {
    title: 'Settlement Settings',
    path: '/application_setting/settlement_setting',
  },
  {
    title: 'Cron Job Settings',
    path: '/application_setting/cron_job_setting',
  },
  {
    title: 'Notification Settings',
    path: '/application_setting/notification_setting',
  },
  {
    title: 'Sample File Settings',
    path: '/application_setting/sample_file_setting',
  },
]

export const med_gemini_model_list = [
  // {
  //   id: 'gemini-1.5-pro',
  //   value: 'gemini-1.5-pro',
  // },
  // {
  //   id: 'gemini-1.5-pro-latest',
  //   value: 'gemini-1.5-pro-latest',
  // },
  // {
  //   id: 'gemini-1.5-pro-001',
  //   value: 'gemini-1.5-pro-001',
  // },
  // {
  //   id: 'gemini-1.5-pro-002',
  //   value: 'gemini-1.5-pro-002',
  // },
  // {
  //   id: 'gemini-1.5-flash',
  //   value: 'gemini-1.5-flash',
  // },
  // {
  //   id: 'gemini-1.5-flash-latest',
  //   value: 'gemini-1.5-flash-latest',
  // },
  // {
  //   id: 'gemini-1.5-flash-001',
  //   value: 'gemini-1.5-flash-001',
  // },
  // {
  //   id: 'gemini-1.5-flash-002',
  //   value: 'gemini-1.5-flash-002',
  // },
  // {
  //   id: 'gemini-1.5-flash-8b',
  //   value: 'gemini-1.5-flash-8b',
  // },
  // {
  //   id: 'gemini-1.5-flash-8b-latest',
  //   value: 'gemini-1.5-flash-8b-latest',
  // },
  // {
  //   id: 'gemini-1.5-flash-8b-001',
  //   value: 'gemini-1.5-flash-8b-001',
  // },

  // gemini-3-pro-preview (Best replacement for Gemini 1.5 Pro)
  // gemini-3-flash-preview (Newest, fastest, and very smart)
  // gemini-2.5-pro (Current stable "thinking" model)
  // gemini-2.5-flash (Current stable fast model)
  // gemini-2.5-flash-lite (Cheapest/fastest for simple tasks)
  // medlm-medium-v1 (Med-Gemini core model)
  // medlm-large-v1 (Highest intelligence for complex clinical reasoning)
  // medgemma-27b (Open medical-tuned model)

  {
    id: 'gemini-3-pro-preview',
    value: 'gemini-3-pro-preview',
  },
  {
    id: 'gemini-3-flash-preview',
    value: 'gemini-3-flash-preview',
  },
  {
    id: 'gemini-2.5-pro',
    value: 'gemini-2.5-pro',
  },
  {
    id: 'gemini-2.5-flash',
    value: 'gemini-2.5-flash',
  },
  {
    id: 'medlm-medium-v1',
    value: 'medlm-medium-v1',
  },
  {
    id: 'medlm-large-v1',
    value: 'medlm-large-v1',
  },
  {
    id: 'medgemma-27b',
    value: 'medgemma-27b',
  },
  {
    id: 'gemini-2.5-flash-lite',
    value: 'gemini-2.5-flash-lite',
  },
]

// export const updateDateFormat = (date: any) => {
//   const currentTime = moment() // Get the current time
//   // Parse the input date and format it without time
//   const parsedDate = moment(date, 'ddd MMM DD YYYY HH:mm:ss ZZ')

//   const formattedDate = parsedDate.format('YYYY-MM-DD') // Format the date

//   // Combine the formatted date with the current time
//   const combinedDateTime = moment(`${formattedDate} ${currentTime.format('HH:mm:ss')}`).utc()
//   console.log('date in util', date, combinedDateTime.format('YYYY-MM-DDTHH:mm:ss.SSSZ'))
//   return combinedDateTime.format('YYYY-MM-DDTHH:mm:ss.SSSZ')

//   // return moment(date).utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
// }

export const updateDateFormat = (date: string) => {
  // const currentTime = moment()

  // const parsedDate = moment(date, 'YYYY-MM-DD', true) // strict parsing

  // const combinedDateTime = parsedDate
  //   .set({
  //     hour: currentTime.hour(),
  //     minute: currentTime.minute(),
  //     second: currentTime.second(),
  //   })
  //   .utc()
  // console.log('date in util', date, combinedDateTime.format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'))
  // return combinedDateTime.format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
  return moment(date).utc()
}

export const camelCase = (str: any) => {
  // // converting all characters to lowercase
  // let ans = str.toLowerCase()

  // // Returning string to camelcase
  // return ans.split(' ').reduce((s: any, c: any) => s + (c.charAt(0).toUpperCase() + c.slice(1)))
  // return str.replace(/[-_]+(.)/g, (_: any, char: any) => char.toUpperCase())
  return str?.charAt(0)?.toUpperCase() + str.slice(1)
}

export function convertToCamelCase(inputString: any) {
  // Remove symbols and split the string into words
  let words = inputString
    ?.toLowerCase()
    .replace(/[^a-zA-Z0-9]+/g, ' ')
    .split(' ')

  // Capitalize the first letter of each word
  for (let i = 0; i < words?.length; i++) {
    words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1)
  }

  // Join the words with spaces
  return words?.join(' ')
}
export const checkMobileNoValid = (number: any) => {
  // if (/^\d*$/.test(number) && number.length <= 10) {
  //   return true
  // } else {
  //   return false
  // }
  if (number === '' || (/^\d*$/.test(number) && number.length <= 10)) {
    return true
  } else {
    return false
  }
}

export const validateNumber = (number: any) => {
  // if (/^\d*$/.test(number) && number.length <= 10) {
  //   return true
  // } else {
  //   return false
  // }
  if (number === '' || (/^\d*$/.test(number) && number.length < 10)) {
    return true
  } else {
    return false
  }
}

export const checkAadharCardValid = (number: any) => {
  if (number === '' || (/^\d*$/.test(number) && number.length <= 12)) {
    return true
  } else {
    return false
  }
}

export const approval_steps = [
  {
    key: 'mobile_number',
    value: 'Mobile Number',
  },
  {
    key: 'mcinumber',
    value: 'MCINumber',
  },
  {
    key: 'email',
    value: 'Email',
  },
  {
    key: 'business_address',
    value: 'Business Address',
  },
]

export const pharmacy_steps = [
  {
    key: 'service_n_subscriptions',
    value: 'Service & Subscriptions',
    selected: false,
  },
  {
    key: 'business_operating_hours',
    value: 'Business Operating Hours',
    selected: true,
  },
  {
    key: 'holidays',
    value: 'Holidays',
    selected: false,
  },
  {
    key: 'currency_settings',
    value: 'Currency Settings',
    selected: false,
  },
  {
    key: 'add_dr_staff',
    value: 'Add Staff',
    selected: false,
  },
]

export const doctor_step = [
  {
    key: 'service_n_subscriptions',
    value: 'Service & Subscriptions',
    selected: false,
  },
  {
    key: 'business_operating_hours',
    value: 'Business Operating Hours',
    selected: true,
  },
  {
    key: 'holidays',
    value: 'Holidays',
    selected: false,
  },
  {
    key: 'consultation_fees',
    value: 'Consultation Fees',
    selected: false,
  },
  {
    key: 'add_dr_staff',
    value: 'Add Dr./Staff',
    selected: false,
  },
  {
    key: 'visiting_hours',
    value: 'Visiting Hours',
    selected: false,
  },
  {
    key: 'add_patient',
    value: 'Add Patient',
    selected: false,
  },
]

export const scan_center_step = [
  {
    key: 'service_n_subscriptions',
    value: 'Service & Subscriptions',
    selected: false,
  },
  {
    key: 'business_operating_hours',
    value: 'Business Operating Hours',
    selected: true,
  },
  {
    key: 'holidays',
    value: 'Holidays',
    selected: false,
  },
  {
    key: 'currency_settings',
    value: 'Currency Settings',
    selected: false,
  },
  {
    key: 'add_dr_staff',
    value: 'Add Staff',
    selected: false,
  },

  {
    key: 'consultation_fees',
    value: 'Lab Charges',
    selected: false,
  },
  {
    key: 'product_Offerings',
    value: 'Product Offerings',
    selected: false,
  },
  {
    key: 'labs',
    value: 'Lab',
    selected: false,
  },
]

export const doctor_certificates = [
  {
    title: 'MCI Certificate',
    certificateName: 'mciCertificates',
  },
  {
    title: 'Aadhar Card',
    certificateName: 'aadharCard',
  },
  {
    title: 'Graduation Degree',
    certificateName: 'graduationDegree',
  },
  {
    title: 'PAN Card',
    certificateName: 'panCard',
  },
  {
    title: 'Intemediate Certificate',
    certificateName: 'intemediateDegree',
  },
]

export const pharma_certificates = [
  {
    title: 'Aadhar Card',
    certificateName: 'aadharCard',
  },
  {
    title: 'Graduation Degree',
    certificateName: 'graduationDegree',
  },
  {
    title: 'PAN Card',
    certificateName: 'panCard',
  },
  {
    title: 'Licence Number',
    certificateName: 'licenceNumber',
  },
]
export const scan_certificates = [
  {
    title: 'Aadhar Card',
    certificateName: 'aadharCard',
  },
  {
    title: 'Graduation Degree',
    certificateName: 'graduationDegree',
  },
  {
    title: 'PAN Card',
    certificateName: 'panCard',
  },
  {
    title: 'NABL',
    certificateName: 'nabl',
  },
]

export const events = ['load', 'mousemove', 'mousedown', 'click', 'scroll', 'keypress']

export function logoutTime(time: any, unit: any) {
  let timer = 0
  if (unit === 'm') {
    timer = parseInt(time) * 60 * 1000
  } else if (unit === 'h') {
    timer = parseInt(time) * 60 * 60 * 1000
  } else if (unit === 'd') {
    timer = parseInt(time) * 24 * 60 * 60 * 1000
  }
  return timer
}

export const useGetDateTimeFormat = (date: any) => {
  const dataUser: any = useSelector((state) => {
    return state
  })
  const dateFormat = dataUser.auth.applicationSetting.date_format || 'YYYY-MM-DD'
  const formattedDate = moment(date).format(dateFormat)
  if (!date) return 'NA' // return empty if no date
  return formattedDate

  // NOTE-> In some cases, custom hook cant be used inside a function that's not a component
  // or another custom hook — such as inside a callback, event handler, map(), or conditional block.
  // So in some cases we have to use the useSelector hook directly to get the date format.
  // To update this search using "dateFormat" throughtout the app
  // And we can't use custom hook also conditionally, it should be used at the top level of the component.
  // So, we have to use the useSelector hook directly to get the date format.
}

export const appointmenttimeFormat = 'ddd, DD MMM YYYY, hh:mm A'

export const setTime = (time: any) => {
  const timeParts = time?.split(':') // Split the string to get hours, minutes, and seconds

  // Create a new Date object for today's date
  const currentDate = new Date()

  // Set the hours, minutes, and seconds of the current date based on the API time
  currentDate?.setHours(parseInt(timeParts[0]))
  currentDate?.setMinutes(parseInt(timeParts[1] || '00'))
  currentDate?.setSeconds(parseInt(timeParts[2] || '00'))
  currentDate?.setMilliseconds(0) // Set milliseconds to zero to avoid potential issues
  return currentDate
}

type Entry = {
  entryType: 'CREDIT' | 'DEBIT'
  amount: string
  id: string
  entryHeading: string
  appointmentId: string
  appointmentDetails: any
  description: string
  currency: string
  paymentId: string
  paymentAmountBreakup: any
  deductionsBreakdown: any
  createdDate: string
}

type Totals = {
  totalCredit: number
  totalDebit: number
  accumulatedBalance: number
}

export function calculateStatementTotals(entries: Entry[]): Totals {
  let totalCredit = 0
  let totalDebit = 0

  entries.forEach((entry) => {
    const amount = parseFloat(entry.amount || '0')

    if (entry.entryType === 'CREDIT') {
      totalCredit += amount
    } else if (entry.entryType === 'DEBIT') {
      totalDebit += amount
    }
  })

  return {
    totalCredit,
    totalDebit,
    accumulatedBalance: totalCredit - totalDebit,
  }
}
